// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.outer[data-v-51c0dd8a]{margin-top:15px}.progress-bar[data-v-51c0dd8a]{margin-top:10px}`, "",{"version":3,"sources":["webpack://./components/modal/AddToAlbumModal.vue"],"names":[],"mappings":"AACA,wBACE,eAAA,CAGF,+BACE,eAAA","sourcesContent":["\n.outer {\n  margin-top: 15px;\n}\n\n.progress-bar {\n  margin-top: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
